/**
 * 원본: .old-gc-mono/apps/gc-zoku/components/pages/GrantYoutubePermissionGuide.js
 * YouTube 권한 부여 안내 페이지
 */
function GrantYoutubePermissionGuide() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: 20,
        flex: 1,
        background: '#f0f2f5',
      }}
    >
      <div style={{ background: 'white', textAlign: 'left', padding: 30, margin: 20, borderRadius: 12 }}>
        <p style={{ fontWeight: 'bold', color: 'red' }}>
          We were not granted all the necessary permissions to access your YouTube account.
        </p>
        <p>Please grant us the required permissions to access your YouTube account.</p>
        <p>It is likely that you missed checking this checkbox during the previous attempt.</p>
        <img
          src="/assets/images/GrantYoutubePermissionGuide/yt_guide_1.png"
          alt="YouTube permission guide step 1"
          style={{ maxHeight: 600, marginTop: 10, marginBottom: 10, maxWidth: '100%' }}
        />
        <br /><br />
        <p>Please try logging in again.</p>
        <img
          src="/assets/images/GrantYoutubePermissionGuide/yt_guide_2.png"
          alt="YouTube permission guide step 2"
          style={{ maxHeight: 600, marginTop: 10, marginBottom: 10, maxWidth: '100%' }}
        />
        <br /><br />
        <p>{'This time, please click "Continue" to grant us the required permissions.'}</p>
        <img
          src="/assets/images/GrantYoutubePermissionGuide/yt_guide_3.png"
          alt="YouTube permission guide step 3"
          style={{ maxHeight: 600, marginTop: 10, marginBottom: 10, maxWidth: '100%' }}
        />
      </div>
    </div>
  );
}

export default GrantYoutubePermissionGuide;
